import React, { Component } from "react";
import { Wrapper } from "app/NativeComponents/common";

import DarkMode from "./DarkMode";
import ProofWrapper from "./ProofWrapper";
import ViewPort from "./ViewPort";
import BranchAndGetParamsWrapper from "./BranchAndGetParamsWrapper";
import IntercomWrapper from "./IntercomWrapper";

import AnalyticsWrapper from "./AnalyticsWrapper";
import PusherWrapper from "app/DealMachineCore/plugins/PusherWrapper";
class Plugins extends Component {
  render() {
    return (
      <Wrapper>
        <DarkMode {...this.props} />
        <ProofWrapper {...this.props} />
        <ViewPort {...this.props} />
        <BranchAndGetParamsWrapper {...this.props} />
        <IntercomWrapper {...this.props} />
        <AnalyticsWrapper {...this.props} />
        <PusherWrapper />
      </Wrapper>
    );
  }
}

export default Plugins;
